import React, { Fragment } from "react";
import { SuccessPanel } from "components/notifications";

export function LicenceCheckingConsentSuccess() {
    return (
        <Fragment>
                <h2>Driver Declaration Submitted</h2>
                <SuccessPanel>
                    <p>
                        Thank you for submitting your Driver Declaration. <br />
                        You may now close this window.
                    </p>
                </SuccessPanel>
        </Fragment>
    );
}
